import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {CloseButton} from '@/components/CloseButton';

export const Container = styled.div(({theme}) => {
  return css`
    pointer-events: auto;

    ${theme.respondUpTo(
      'lg',
      css`
        /* https://www.bram.us/2021/07/08/the-large-small-and-dynamic-viewports/#dynamic-viewport */
        height: 100vh;
        height: calc(100vh - env(safe-area-inset-bottom));
        height: 100dvh;
        /* @FIXME */
        [data-testid='shared-searchForm'] {
          box-sizing: border-box;
          height: 100%;
        }
        /* @FIXME */
        [data-testid='view-switch'] {
          margin: -16px -16px 16px;
          border-radius: 0;
        }

        > ${CloseButton} {
          position: absolute;
          top: 4px;
          right: 4px;
        }
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        padding: 12px 0;
        background-color: ${theme.colors.backgroundBrand};
      `
    )}
  `;
});
